import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPeertubeComponent } from './simple-icons-peertube.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPeertubeComponent ],
    exports:      [ SimpleIconsPeertubeComponent ],
    bootstrap:    []
})
export class SimpleIconsPeertubeModule {}
